import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import './style.css'

import { toast } from 'react-toastify'

import { useSelector, useDispatch } from 'react-redux'
import { createResourceTag, getResourceTag, editResourceTag } from '../../../../pages/features/resourcetag/resourcetagSlice'

// import { ResourceData } from './resources.data'
import { TableHeader } from '../../../../components/tableheader'
import { TableData } from './tabledata'
// import { TableData } from '../../../../components/tabledata'

import { Button } from '../../../../components/button'
import Spinner from '../../../../components/spinner'

const DashTags = () => {
    const [addResource, setAddResource] = useState(false)
    const [resourceTagName, setResourceTagName] = useState('')
    const [resourceType, setResourceType] = useState('')

    const handleAddResource = (e) => {
      if(canEdit){
        setCanEdit('')
        setAddResource(false)
        setResourceTagName('')
        setResourceType('')
       } else {
        setAddResource(!addResource)
       }

    }

    const dispatch = useDispatch();

    const { resourceTag, isLoading, isError, resourceTagCreatedStatus, isSuccess, message } = useSelector(state => state.resourceTag);
    const [resourceTagsState, setResourceTagsState] = useState(resourceTag || [''])
    const [searchTerm, setSearchTerm] = useState('')

    const [updateUIWithout, setUpdateUIWithout] = useState(''); //Update UI after deleting
    const [canEdit, setCanEdit] = useState('') //Edit resourceCategory state

    //updateUI without
  useEffect(()=> {
    setResourceTagsState([...resourceTagsState.filter((resource) => resource.resourceTagId !== updateUIWithout)])
  }, [updateUIWithout])


  //searchTerm state watcher
  useEffect(()=> {
    setResourceTagsState([...resourceTagsState.filter((resource) => resource?.resourceTagName?.toLowerCase().includes(searchTerm.toLowerCase()) || resource?.resourceTagType?.toLowerCase().includes(searchTerm.toLowerCase()))])

  }, [searchTerm])


   //canEdit state watcher
   useEffect(()=> {
    if(canEdit){
      // alert("You can edit now")
      setAddResource(true)

      const cateogoryToEdit = resourceTagsState.filter((tag) => tag.resourceTagId === canEdit)[0]

      setResourceTagName(cateogoryToEdit['resourceTagName'])

      setResourceType(cateogoryToEdit['resourceType'])

    }
  }, [canEdit])

  
  // handlers
  const onSearchTextInput = (e) => {
      setSearchTerm(e.target.value)
  }


    useEffect(() => {
       
        dispatch(getResourceTag());

    }, [resourceTagCreatedStatus]);

    if(isLoading) {
      return <Spinner />;
  }


    const handleSubmit = (e) => {
      e.preventDefault();
      
      {
        const resourceTagData = {
          resourceTagName,
          resourceType
        }
        if(canEdit){
          dispatch(editResourceTag({...resourceTagData, resourceTagId: canEdit}))
          const indexOfEdited = resourceTagsState.indexOf(resourceTagsState.find((tag) => tag.resourceCategoryId === canEdit))
  
          // const editedCategory = resourceCategoriesState.splice(indexOfEdited, 1)
  
          //Replace old edited category with updated
          delete resourceTagData['resourceTagId']
          resourceTagsState.splice(indexOfEdited, 1, resourceTagData)
  
          setResourceTagsState(resourceTagsState)
          // console.log(resourceCategoriesState)
          // setResourceCategoriesState()
  
          setCanEdit('')
  
  
        } else {
          dispatch(createResourceTag(resourceTagData))
        }
        

        setResourceTagName('')

        if(isError){
          toast(message)
        }else if(isSuccess){
          toast.success("You have successfully created a new tag", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
        }
      
      }
      
  }

  if(isLoading) {
      return <Spinner />;
  }

  return (
    <Container className='body_cont'>
      
      <PageHeader>
        <h2>Tags</h2>
        
        <div className='search_bar'>
          <input type="text" name='tagSearch' id='tagSearch'  placeholder='Search items' onChange={onSearchTextInput} />
          <div onClick={handleAddResource} >
          <Button filled bgColor={'#2A870E'} text={canEdit || addResource ? 'Cancel' : ' + Add'} noIcon reverse />
          </div>
          
        </div>
      </PageHeader>

{addResource ?
      <AddResource>

        <form onSubmit={handleSubmit} > 

        <MainForm>
            <div>
              <label htmlFor="tag">Tag name*</label>
              <input type="text" name='resourceTagName' id='resourceTagName' value={resourceTagName} onChange={ (e) => setResourceTagName(e.target.value)}  placeholder='Enter category name' required />
            </div>

            <div>
              <label htmlFor="category">Type*</label>
              <select name="resourceType" id="resourceType" 
                onChange={(e) => {setResourceType(e.target.value) 
                console.log(e.target.value)
              
                }}>
                <option value="">Select Resource Type</option>
                <option value="internal">Nigeriana</option>
                <option value="external">Open Access Resources</option>
              </select>
          </div>    
        {/* </DividedInput> */}


        
        </MainForm>

        <div className='publish'>
        <div className='note'>Note: Fields marked with * are required.</div>
          <Button filled bgColor={'#2A870E'} text={'Publish'} noIcon reverse />
        </div>
        
        </form>
        
      </AddResource>
:
null
}

<section>
        <TableHeader newpaperName={'Tag name'} authorName={'Type'} />
         { resourceTagsState.length > 0 ? (
          
          <>
           {
              resourceTagsState?.slice(0, 20)?.map((tag) => {
                // console.log(tag)
                return (

                  // <TableData key={tag._id} tag={tag} />'
                  
                <TableData tag={tag} key={tag.resourceTagId} setUpdateUIWithout={setUpdateUIWithout} setCanEdit={setCanEdit}
                />               
                  )
                })
            }    
          
          </>

         ) : ( <h4>You have no tags</h4> )

         }

                       

</section>


      

      
    </Container>
  )
}

const Container = styled.section`
  padding-top: 40px;
  padding-left: 30px;
  padding-right: 30px;
  width: 100%;

  @media only screen and (max-width: 760px){
    padding-top: 20px;
    padding-left: 10px;
    padding-right: 10px;
  }
`

const PageHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media only screen and (max-width: 760px){
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  h2 {
      margin-bottom: 10px;

      @media only screen and (max-width: 760px){
        text-align: left !important;
        align-self: flex-start;
      }
    }

    


  & > div{
    display: flex;
    height: 40px;
    width: 100%;

    & > input{
      /* outline: none; */
      width: 90% !important;
      padding: 1rem;
      background-color: inherit;
      border-radius: 4px;
      border: 1px solid #D0D5DD;
    }

    & button{
      padding: 1rem;
      margin-left: 1rem;
      /* width: 50px; */
    }
  }
`

const AddResource = styled.div`
  padding: 0px 25px 0;
  border: 1px solid #D0D5DD;
  margin-top: 30px;
  margin-bottom: 30px;

  & form {


    & > :last-child{
      margin-top: 3rem;
      border-top: 1px solid #D0D5DD;
      align-self: flex-end;
      padding: 1rem 0;
    }
    & button{
      padding: 1rem;
      margin-left: 1rem;
      align-self: flex-end;
      /* margin-top: 3rem; */

      /* border: 1px solid red; */

      /* width: 50px; */
    }
  }
`



const MainForm = styled.div`


  & > div{

    display: flex;
    flex-direction: column;
    width: 100% !important;

    & > input{
      background-color: inherit;
      height: 44px;
      padding: 1rem;
      border-radius: 4px;
      border: 1px solid #D0D5DD;
      width: 100% !important;
      
  }

    & > label{
      font-size: 14px;
      font-weight: 500;
      margin-top: 25px;
      margin-bottom: 0.8rem;
      /* color: #667085; */
    }

    & > select{
      background-color: inherit;
      height: 44px;
      padding: 1rem;
      border-radius: 4px;
      border: 1px solid #D0D5DD;
      width: 100% !important;

      & > option{
        padding: 4rem;
      }
    }

    & > textarea{
      height: 10rem;
      padding: 1rem;
      border-radius: 4px;
      border: 1px solid #D0D5DD;
      background-color: #fff;

    }

    
  }
`

const DividedInput = styled.section`
 

  & > div{
    display: flex;
    flex-direction: column;
    

    

  &  label{
      font-size: 14px;
      font-weight: 500;
      margin-top: 10px;
      margin-bottom: 5px;

    }

  }
`

export {DashTags}